import React from 'react';
import './index.scss';
import LoadIcon from '@/assets/images/jkc/createTask/load-icon.png';
import UnloadIcon from '@/assets/images/jkc/createTask/unload-icon.png';
import { OrderStateEnum } from '@/jkc/utils/constant'; // Import OrderStateEnum
import { useNavigate } from 'react-router-dom';
import { qidianLog } from '@/utils';

const VehicleCard = ({ order }: { order: any }) => {
  const navigate = useNavigate();
  const {
    deliveryCarInfo,
    deliveryTripDetail,
    orderState,
    deliveryServiceInfo
  } = order;

  const getTipInfo = () => {
    switch (orderState) {
      case OrderStateEnum.WAIT_DISPATCH:
        return '寻找车辆中';
      case OrderStateEnum.DISPATCHED:
        return '已匹配到车辆';
      case OrderStateEnum.PICKUP_EN_ROUTE:
        return '正在前往装货点';
      case OrderStateEnum.WAIT_LOAD:
      case OrderStateEnum.LOADING:
        return '已到达装货点';
      case OrderStateEnum.IN_TRANSIT:
        return '正在前往卸货点';
      case OrderStateEnum.WAIT_UNLOAD:
      case OrderStateEnum.UNLOADING:
        return '已到达卸货点';
    }
  };

  const checkDetail = () => {
    navigate(
      `/jkc/orderDetail?orderId=${order.orderId}&storeId=${order.storeId}`
    );
    qidianLog('transport_workbench|viewOngoingOrders', {
      orderId: order.orderId
    });
  };

  return (
    <div className="vehicle-card" onClick={checkDetail}>
      <div className="vehicle-card-left">
        <div className="tip-info">{getTipInfo()}</div>
        <div className="route-detail">
          <div className="route-item">
            <img className="select-stop-jkc-icon" src={LoadIcon} />
            <span className="route-name">
              {deliveryTripDetail.pickUpPoint.title}
            </span>
          </div>
          <div className="route-item">
            <img className="select-stop-jkc-icon" src={UnloadIcon} />
            <span className="route-name">
              {deliveryTripDetail.dropOffPoint.title}
            </span>
          </div>
        </div>
      </div>
      <div className="vehicle-card-right">
        <img
          className={deliveryCarInfo.frontViewUrl ? 'call-car' : 'not-call-car'}
          src={
            deliveryCarInfo.frontViewUrl
              ? deliveryCarInfo.frontViewUrl
              : 'https://img11.360buyimg.com/imagetools/jfs/t1/381148/31/5912/22320/694a4d9bF272c9799/03e60de0a890f9f4.png'
          }
        />
        <span className="plate-number">{deliveryCarInfo.plateNum}</span>
      </div>
    </div>
  );
};

export default VehicleCard;
